import { useTranslation } from '@wix/form-fields';
import React from 'react';
import { useSubmitStatus } from '../../contexts/submit-status-context';
import { FadeOut } from './fade-out';
import { SubmitErrorMessage } from './submit-error-message';
import styles from './submit-status-message.module.scss';
import { SubmitThankYouMessage } from './submit-thank-you-message';
export const SubmitStatusMessage = ()=>{
    const { isSubmitting, submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        role: "status"
    }, isSubmitting && /*#__PURE__*/ React.createElement("span", {
        className: styles.visuallyHidden
    }, t('form.submit-button.state.in-progress')), /*#__PURE__*/ React.createElement(FadeOut, {
        visible: !!submitSuccessMessage
    }, /*#__PURE__*/ React.createElement(SubmitThankYouMessage, {
        messageText: submitSuccessMessage
    }))), /*#__PURE__*/ React.createElement("div", {
        role: "alert"
    }, /*#__PURE__*/ React.createElement(SubmitErrorMessage, {
        errorMessageCode: submitFailureCode,
        errorMessage: submitFailureMessage
    })));
};

//# sourceMappingURL=submit-status-message.js.map